import format from 'date-fns/format';
import { clean, prepareBookingParams } from '@/utils';
import { ListingFilterDateFlexibilityEnum } from '@/__generated__/graphql';

const dayPalette = {
  1: ListingFilterDateFlexibilityEnum.OneDay,
  2: ListingFilterDateFlexibilityEnum.TwoDays,
  3: ListingFilterDateFlexibilityEnum.ThreeDays,
  7: ListingFilterDateFlexibilityEnum.SevenDays,
};

export const RATINGS = {
  5: {
    min: 4.5,
    max: 5,
  },
  4: {
    min: 4,
    max: 4.5,
  },
  3: {
    min: 3.5,
    max: 4,
  },
  0: {
    min: 0,
    max: 0,
  },
};

export const TABS_FACETS = {
  best_deal: true,
  close_to_city_centre: true,
  family_apartment: true,
  long_stay: true,
};

export const listTabs = [
  {
    slug: 'your-search',
    iconName: 'your_search',
    name: '',
  },
  {
    iconName: 'best_deal',
    slug: 'best_deal',
    facetName: 'best_deal',
  },
  {
    iconName: 'close_to_city_centre',
    slug: 'close_to_city_centre',
    facetName: 'close_to_city_centre',
  },
  {
    iconName: 'family_apartment',
    slug: 'family_apartment',
    facetName: 'family_apartment',
  },
  {
    iconName: 'long_term_stays_allowed',
    slug: 'long_stay',
    facetName: 'long_stay',
  },
];

export const getListingsVariables = (
  inexactStay,
  guests,
  location,
  pets,
  date,
  price,
  amenities,
  rooms,
  rating,
  tab,
) => {
  const params = prepareBookingParams({
    guests: guests || {},
    pets,
    date: date || {},
    location: location || {},
    inexactStay,
    rating,
    rooms: rooms || {},
    price: price || {},
    amenities: amenities || [],
    tab,
  });

  const totalGuests = Object.keys(params.guests).reduce((acc, type) => {
    const qty = params.guests[type] || 0;
    return acc + qty;
  }, 0);

  const nextDate =
    params.dateRange.startDate && params.dateRange.endDate
      ? {
          startDate: format(params.dateRange.startDate, 'yyyy-MM-dd'),
          endDate: format(params.dateRange.endDate, 'yyyy-MM-dd'),
        }
      : undefined;

  const nextParams = {
    filters: {
      availability: nextDate
        ? { ...nextDate, dateFlexibility: dayPalette[params.dateFlexibility] }
        : undefined,
      locationId: params.location?.id || 'SE',
      occupancy: {
        numBeds: params?.rooms?.beds || undefined,
        numBedrooms: params?.rooms?.bedrooms || undefined,
        numBathrooms: params?.rooms?.bathrooms || undefined,
        numGuests: totalGuests,
        withPets: params.pets,
      },
      price: {
        min:
          params?.price?.min || params?.price?.max
            ? Number(params?.price?.min || 0)
            : undefined,
        max: Number(params?.price?.max || 0) || undefined,
      },
      rating: RATINGS[params.rating] ? RATINGS[params.rating] : undefined,
      amenitiesIds: params.amenities || undefined,
      facetName: TABS_FACETS[params.tab] ? params.tab : undefined,
    },
  };

  return clean(nextParams);
};
